import {initStylizedYandexMap} from '../../elements/div.infrastructure-map/index.js';

const EXPAND_ITEM_CLASS = 'expand-item';

const isListItemExpand = ( listItem ) => listItem.classList.contains( EXPAND_ITEM_CLASS );

const expandItem = ( clickedItem, expendingItem, container, closeButton = clickedItem ) => {
	const isExpand = isListItemExpand( container );
	const isOnClose = closeButton && isExpand;

	if ( !isExpand || isOnClose )
	{
		expendingItem.style.height = `${expendingItem.firstChild.offsetHeight}px`;
	}

	if ( !isExpand )
	{
		expendingItem.addEventListener( 'transitionend', () => {
			if ( isListItemExpand( container ) )
			{
				expendingItem.style.height = 'auto';
			}
		}, {once: true} );

		container.classList.add( EXPAND_ITEM_CLASS );
	}

	if ( isOnClose )
	{
		container.classList.remove( EXPAND_ITEM_CLASS );
		setTimeout( () => {
			expendingItem.style.height = '';
		}, 10 );
	}
};

// const onChangeFilters = (map) => {
	// const filters  = map.querySelectorAll( 'button.filter' );

	// if ( !filters.length )
	// {
	// 	return;
	// }

	// map.addEventListener( 'click', ( {target} ) => {
	// 	if ( target.closest( 'button.filter' ) )
	// 	{
	// 		filters.forEach( ( filter ) => filter.classList.remove( 'active' ) );

	// 		target.closest( 'button.filter' ).classList.add( 'active' );
	// 	}
	// } )
// }

const initContacts = () => {
	const component = document.querySelector( 'section.contacts' );
	const itemsWrapper = component?.querySelector( 'ul.expanding-list' );

	if ( !component || !itemsWrapper )
	{
		return;
	}
	
	itemsWrapper.addEventListener( 'click', ( {target} ) => {
		const listItem = target.closest( 'div.header-wrapper' );
		
		if ( listItem )
		{
			const expendingItem = listItem.nextSibling;
			
			const closeButton = target.closest( 'div.header-wrapper' );
			
			if ( expendingItem && closeButton )
			{
				expandItem( listItem, expendingItem, listItem, closeButton );
			}
		}
	} );

	// onChangeFilters( component );

	initStylizedYandexMap( component )
}

export {
	initContacts,
}
